module.exports = __webpack_public_path__ + "static/media/tsi_help5.2b9f250e.png";